function getHomePath() {
  try {
    const store = require('../index').default;
    const role = store?.state?.user?.userInfo?.role;
    const { isStaffRole } = require('../../constants/roles');
    if (role && isStaffRole(role)) return '/my-tasks';
  } catch (_) { /* ignore */ }
  return '/dashboard';
}

export default {
  namespaced: true,
  state: {
    tabs: [{ path: '/dashboard', title: '首页', affix: true }],
    active: '/dashboard',
  },
  mutations: {
    INIT_HOME(state) {
      const homePath = getHomePath();
      const homeTitle = homePath === '/my-tasks' ? '我的任务' : '首页';
      state.tabs = [{ path: homePath, title: homeTitle, affix: true }];
      state.active = homePath;
    },
    OPEN(state, { path, title, affix }) {
      if (!state.tabs.find(t => t.path === path)) {
        state.tabs.push({ path, title, affix: !!affix });
      }
      state.active = path;
    },
    CLOSE(state, path) {
      const idx = state.tabs.findIndex(t => t.path === path);
      if (idx > -1 && !state.tabs[idx].affix) {
        state.tabs.splice(idx, 1);
      }
    },
    CLOSE_OTHERS(state, path) {
      state.tabs = state.tabs.filter(t => t.affix || t.path === path);
      state.active = path;
    },
    CLOSE_ALL(state) {
      state.tabs = state.tabs.filter(t => t.affix);
      state.active = state.tabs[0]?.path || getHomePath();
    },
    SET_ACTIVE(state, path) {
      state.active = path;
    },
  },
};
